export { default } from './Portal';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Portal/index.js
// module id = 246
// module chunks = 0